import React from 'react';

function StoreHome() {
  return <div>Home</div>;
}

export default StoreHome;
